import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(() => ({
    contenedor: {
      marginTop: '15px',
    },
    tituloPrincipal: {
      fontFamily: 'Roboto',
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "27px",
      lineHeight: "27px",
      textAlign: "center",
      color: "#000000",
    },
    divider: {
        padding: '3px',
        background: '#205690',
        margin: '0 auto',
        marginBottom: '1rem',
        marginTop: (props) => props.showButton ? '1rem' : 0,
    },
    icon: {
      display: 'block',
      width: prop => prop?.widthIcon ? prop.widthIcon : "65px",
      height: prop => prop?.heighIcont ? prop.heighIcont : "65px",
    },
    tiempo: {
      display: "flex",
      flexDirection: "column",
      alignItems: 'center',
      justifyContent: "center",
      width: "85px",
      height: "50px",
      background: "#D9D9D9",
      margin: '10px 0px'
    },
    boton: {
      marginBottom: '10px',
      background: "#E9EAE5",
      color: "#000000",
    },
    texto: {
      fontFamily: 'Roboto',
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "18px",
      lineHeight: "27px",
      color: '#000000'
    }
  }));